import React, { useContext } from 'react';

import { UploadedFile } from '../../../../api-client';
import { ymAsync } from '../../../../utils/functions/ymWrapper';
import IdentificationContext from '../../../context/IdentificationContext';
import IdentificationFileUpload from '../IdentificationFileUpload';

const FirstScanUpload = () => {
  const context: any = useContext(IdentificationContext);
  const loadFiles = (files: Array<UploadedFile>) => {
    ymAsync('verification-passport-1-input');
    context.setFirstPassportScans(files);
  };

  return (
    <IdentificationFileUpload
      prefix="first"
      text="Разворот с фотографией"
      files={context.firstPassportScans}
      onUploaded={loadFiles}
    />
  );
};

export default FirstScanUpload;
